import { inject, Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  private messageService = inject(MessageService);
  constructor() {}

  public success(message: string, ...args: ToastMessageOptions[]) {
    this.messageService.add({
      ...args[0],
      severity: 'success',
      summary: 'Success',
      detail: message,
    });
  }

  public error(message: string, ...args: ToastMessageOptions[]): void {
    this.messageService.add({ ...args[0], severity: 'error', summary: 'Error', detail: message });
  }

  public warning(message: string, ...args: ToastMessageOptions[]) {
    this.messageService.add({ ...args[0], severity: 'warn', summary: 'Warn', detail: message });
  }
}
